<template>
  <DsShowcase title="InputRangePlay" description="Slider/range input.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model: number</code></p>
      <div class="tw:max-w-lg tw:space-y-4">
        <InputRangePlay v-model="val1" />
        <p class="tw:text-xs tw:opacity-50">Valor: {{ val1 }}</p>
      </div>
    </section>

    <!-- Min / Max -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">min / max</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — limites do slider</p>
      <div class="tw:max-w-lg tw:space-y-4">
        <InputRangePlay v-model="val2" :min="0" :max="10" />
        <p class="tw:text-xs tw:opacity-50">Valor: {{ val2 }} (0-10)</p>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { InputRangePlay } from '@/components/atomic'

const val1 = ref(50)
const val2 = ref(5)
</script>
